import React, { useEffect, useState } from 'react';
// import { Link as RouterLink, withRouter } from 'react-router-dom';
// import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// import { formatNumber } from 'utils/helper';
import { fetchUserRankApi } from 'utils/clientApis';
import RankTable from './Ranks/RankTable';
import { makeStyles } from '@material-ui/styles';
import {
  Typography
} from '@material-ui/core';
import CustomCircularProgress from 'views/Peloton/shared/CustomCircularProgress';

const Ranks = prop => {
  const classes = useStyles();
  const { t } = useTranslation(['page']);
  const stringedId = String(prop.data.id);

  const [wkgRank, setWkgRank] = useState([]);
  const [tssRank, setTssRank] = useState([]);

  useEffect(() => {
    handleFetchRank();
  }, []);

  const handleFetchRank = async () => {
    try {
      const response = await fetchUserRankApi(stringedId);
      setWkgRank(sortByDataResult(response.data.response.wkg, 'wkg'));
      setTssRank(sortByDataResult(response.data.response.weekTss, 'lastWeekTss'));
    } catch (err) {
      console.error(err);
    }
  };

  const sortByDataResult = (dataArray, key) => {
    const filteredData = dataArray.filter(item => !item.displayName.startsWith('__'));
    return filteredData.sort((a, b) => b[key] - a[key]);
  };

  const RankTableWithTitle = ({ title, keyData, keyword }) => (
    <>
      <Typography className={classes.title} style={{ marginBottom: '16px' }}>
        {title}
      </Typography>
      <RankTable keyData={keyData} keyword={keyword} />
    </>
  );

  return (
    <>
      {wkgRank.length && tssRank.length ? (
        <>
          <RankTableWithTitle title="FTP(w/Kg) 랭킹" keyData={wkgRank} keyword="w/kg" />
          <RankTableWithTitle title="wTSS 랭킹" keyData={tssRank} keyword="wTSS" />
        </>
      ) : (
        <CustomCircularProgress />
      )}
    </>
  );
};
export default Ranks;

const useStyles = makeStyles(theme => ({
  root: {
    //    padding: theme.spacing(2)
  },
  topBar: {
    paddingBottom: '8px',
    marginBottom: '16px'
  },
  title: {
    fontSize: '16px',
    color: '#455A64',
    fontWeight: '700',
    padding: '0px',
    [theme.breakpoints.up('md')]: {
      fontSize: '16px'
    }
  },
  chapter: {
    backgroundColor: 'white',
    marginTop: '2px',
    padding: '24px',
    height: '100vh'
  },
  info: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    '& > *': {
      marginRight: '2px'
    }
  },
  info2: {
    display: 'flex',
    justifyContent: 'end',
    '& > *': {
      marginRight: '2px'
    }
  },
  cards: {
    marginBottom: '16px'
  },
  header: {
    display: 'flex',
    padding: '16px',
    height: '24px'
  },
}));
